// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import Header from './components/header/HeaderComp';
// import Footer from './components/footer/FooterComp';
// import BackToTopComp from './components/backtotop/BacktoTopComp';
// import reportWebVitals from './reportWebVitals';
// import { BrowserRouter } from 'react-router-dom';
// import { HelmetProvider } from 'react-helmet-async';

// // Root render
// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <HelmetProvider>
//       <BrowserRouter>
//         <div className="font-poppins antialiased px-5 sm:px-10 md:px-14 lg:px-20">
//           <Header />
//           <main className="flex flex-col gap-10 md:gap-20">
//             <App />
//           </main>
//           <Footer />
//           <BackToTopComp />
//         </div>
//       </BrowserRouter>
//     </HelmetProvider>
//   </React.StrictMode>
// );

// reportWebVitals();


import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import Header from "./components/header/HeaderComp";
import Footer from "./components/footer/FooterComp";
import BackToTopComp from "./components/backtotop/BacktoTopComp";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

const rootElement = document.getElementById("root");

const MainApp = (
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <div className="font-poppins antialiased px-5 sm:px-10 md:px-14 lg:px-20">
          <Header />
          <main className="flex flex-col gap-10 md:gap-20">
            <App />
          </main>
          <Footer />
          <BackToTopComp />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// If react-snap has already pre-rendered HTML, hydrate it.
// Otherwise, render normally during development.
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, MainApp);
} else {
  const root = createRoot(rootElement);
  root.render(MainApp);
}

reportWebVitals();